import type { NetworkParams } from './types'

export const match = (hostname: string): boolean => /go\.yeshearing\.com/.test(hostname)
export const compactTracking = true

export const apply = (url: URL, params: NetworkParams): void => {
  if (!url.searchParams.get('cid')) {
    return
  }
  if (params.trackingId) {
    url.searchParams.set('sub1', params.trackingId)
    url.searchParams.delete('sub2')
    url.searchParams.delete('sub3')
    url.searchParams.delete('src')
    return
  }
  if (params.content) {
    url.searchParams.set('sub1', params.content)
  }
  url.searchParams.set('sub2', params.pathname)
  url.searchParams.set('sub3', params.utmSearch)
  url.searchParams.set('src', params.term)
}
